<script>
  import SugorokuCircle from '@/components/atoms/SugorokuCircle.vue'
  import Walker from '@/components/atoms/Walker.vue'

  export default {
    name: 'Sugoroku',
    components: {
      SugorokuCircle,
      Walker
    },
    computed: {
      circles() {
        return this.$store.state.circles;
      }
    },
    methods: {
      clickCircle(i) {
        const { commit } = this.$store;
        if (i < 3) {
          commit('openModalCheckpoint', i);
        } else if (i === 4) {
          commit('openModalCheckpoint', 3);
        } else if (i === 9) {
          commit('openModalCheckpoint', 4);
        } else if (i === 14) {
          commit('openModalCheckpoint', 5);
        } else if (i === 19) {
          commit('openModalCheckpoint', 6);
        }
      }
    }
  }
</script>

<template lang="pug">
  .sugoroku
    SugorokuCircle(
      v-for = 'circle, index in circles'
      :x = 'circle.x'
      :y = 'circle.y'
      :w = 'circle.w'
      :h = 'circle.h'
      :i = 'index'
      :key = "`cir_${index}`"
      @click = 'clickCircle(index)'
      )
    .sugoroku__walker
      Walker
</template>

<style lang="scss">
  .sugoroku {
    width: 100%;
    position: relative;
    padding-top: 724 / 750 * 100%;
    z-index: 1;
    &:before, &:after {
      width: 100%;
      height: 100%;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
      background-size: cover;
    }
    &:before {
      z-index: 100;
      background-image: url('~@/assets/img/sugoroku_fw.png');
    }
    &:after {
      background-image: url('~@/assets/img/sugoroku_bg.png');
    }
    &__walker {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transform: translateZ(1px);
      transform-style: preserve-3d;
      z-index: 100;
      pointer-events: none;
    }
  }
</style>
